import { NewPaymentMethodDelegate } from 'billing/payment-methods/PaymentMethodsRootViewModel'
import ProfilePaymentMethodsViewModel from 'iam/screens/Profile/Billing/PaymentMethods/ProfilePaymentMethodsViewModel'
import BillingStore from 'billing/BillingStore'
import Member from 'iam/models/Member'
import ProfilePayoutMethodViewModel from './PayoutMethod/ProfilePayoutMethodViewModel'
import {
  StripeConnectCallbackModalViewModel,
  StripeConnectCallbackDelegate,
} from 'billing/screens/StripeCallback/StripeCallbackViewModel'
import { task } from 'mobx-task'
import PayoutMethodStore from 'payouts/pro/PayoutMethodStore'
import { computed, makeObservable } from 'mobx'
import { Router } from 'types/definitions'
import link from 'infra/link'

/**
 * View model for the General tab.
 */
export default class ProfileGeneralViewModel {
  stripeConnectModalVM = new StripeConnectCallbackModalViewModel()
  stripeCbDelegate = new StripeConnectCallbackDelegate(
    async () => null,
    this.member,
    this.billingStore,
    this.payoutMethodStore,
  )

  paymentMethodsVM = new ProfilePaymentMethodsViewModel(
    this.member,
    this.billingStore,
    this.newPaymentMethod,
  )

  payoutMethodVM = new ProfilePayoutMethodViewModel(
    this.member,
    this.billingStore,
    this.payoutMethodStore,
  )

  constructor(
    private member: Member,
    private billingStore: BillingStore,
    private newPaymentMethod: NewPaymentMethodDelegate,
    private payoutMethodStore: PayoutMethodStore,
    private router: Router,
  ) {
    makeObservable(this)
  }

  /**
   * Determines if payouts is enabled.
   */
  @computed
  get isPayoutsEnabled() {
    return this.payoutMethodStore.isPayoutsEnabled
  }

  /**
   * Activates the view model.
   */
  activate = task(async () => {
    await this.paymentMethodsVM.activate()

    // Complete stripe payout connection
    if (this.stripeCbDelegate.hasPendingConnection()) {
      await this.completeStripeConnectFlow()
    }

    if (this.isPayoutsEnabled) {
      await this.payoutMethodVM.activate()
    }
  })

  completeStripeConnectFlow = task(async () => {
    this.router.push(link.profileBillingPayoutMethod())
    this.stripeConnectModalVM.show()

    await this.stripeCbDelegate.finishConnection()
  })

  /**
   * Deactivates the view model.
   */
  deactivate() {
    //
  }
}
